<template>
  <b-modal id="publish-modal" ref="modal" hide-footer centered>
    <template slot="modal-header">
      <div class="m-modal-header">
        <h2 class="top-title mb-0">免费发布项目</h2>
        <img
          src="@/assets/images/icon_modal_close.png"
          alt
          class="close-button"
          @click.stop="hide"
        />
      </div>
    </template>
    <template slot="default">
      <div class="m-modal-content">
        <form>
          <fieldset>
            <span class="name">项目名称：</span>
            <input type="text" placeholder="请输入项目名称" v-model="name" />
          </fieldset>
          <fieldset>
            <span class="name"> 项目类型：</span>
            <select name="type" id="type" v-model="type">
              <option value="" class="name" selected disabled
                >请选择项目类型</option
              >
              <option
                :value="item"
                v-for="(item, index) in typeList"
                :key="index"
                >{{ item }}</option
              >
            </select>
          </fieldset>
          <fieldset>
            <span class="name">项目预算：</span>
            <input type="text" placeholder="请输入项目预算" v-model="price" />
          </fieldset>
          <fieldset>
            <span class="name">项目周期：</span>
            <input type="text" placeholder="请输入项目周期" v-model="time" />
          </fieldset>
          <fieldset>
            <span class="name">项目描述：</span>
            <textarea
              name=""
              cols="30"
              rows="3"
              placeholder="请输入项目描述"
              v-model="remark"
            ></textarea>
          </fieldset>
          <fieldset>
            <span class="name">项目要求：</span>
            <textarea
              name=""
              cols="30"
              rows="3"
              placeholder="请输入项目要求"
              v-model="requirement"
            ></textarea>
          </fieldset>
          <fieldset class="upload">
            <span class="name">上传图片：</span>
            <input
              type="file"
              ref="file"
              name="file"
              id="file"
              style="display: none;"
              @change="handleFileUpload"
            />
            <img
              :src="fileThumb"
              class="upload-placeholder"
              alt=""
              @click="addFile"
              v-if="fileThumb"
            />
            <img
              src="@/assets/images/icon_upload.png"
              class="upload-placeholder"
              alt=""
              @click="addFile"
              v-else
            />
          </fieldset>
        </form>
        <button
          class="confirm-button d-block mx-auto my-5"
          @click.stop="confirm"
        >
          确认
        </button>
      </div>
    </template>
  </b-modal>
</template>
<style lang="scss" scoped>
#publish-modal {
  width: 60%;
  .m-modal-header {
    width: 100%;
    display: flex;
    align-items: center;
    .top-title {
      flex: 1;
      font-size: 1.25rem;
      color: #333333;
      text-align: left;
      border-left: 0.19rem $acentColor solid;
      padding-left: 0.5rem;
    }
    .close-button {
      color: $acentColor;
      &:hover {
        cursor: pointer;
      }
    }
  }
  .m-modal-content {
    form {
      fieldset {
        margin-bottom: 1rem;
        text-align: left;
        span.name,
        option.name {
          font-size: 1.13rem;
          color: #333333;
          vertical-align: top;
          display: inline-block;
          height: 2.38rem;
          text-align: left;
        }
        input[type='text'],
        select,
        textarea {
          width: 75%;
          padding-left: 0.5rem;
          outline: none;
          border: solid 0.06rem #e5e5e5;
          resize: none;
          &::placeholder {
            font-size: 1.13rem;
            color: #999999;
          }
        }

        input[type='text'],
        select {
          height: 2.38rem;
        }
        &.upload {
          .upload-placeholder {
            width: 125px;
            height: 125px;
            object-fit: cover;
            cursor: pointer;
          }
        }
      }
    }
    .confirm-button {
      font-size: 1.25rem;
      color: white;
      width: 60%;
      height: 2.88rem;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: $acentColor;
      border: none;
      outline: none;
    }
  }
}
</style>

<script>
import ApiService from '@/common/api.service';
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      typeList: [
        '品牌设计',
        '品牌策划',
        '效果图',
        '数字模型',
        '视觉影视',
        '软件平台',
        '新媒体',
        '互动展项',
        '展览展示',
        '国际进驻',
        '媒体推广',
        '展厅运维'
      ],
      name: '',
      type: '',
      price: '',
      time: '',
      remark: '',
      requirement: '',
      file: '',
      fileThumb: ''
    };
  },
  computed: {
    ...mapGetters(['accountName'])
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    confirm() {
      if (!this.accountName) {
        window.alert('登陆之后才能发布项目');
        this.$router.push('/login');
        return;
      }
      let param = new FormData();
      param.append('name', this.name);
      param.append('type', this.type);
      param.append('price', this.price);
      param.append('time', this.time);
      param.append('remark', this.remark);
      param.append('requirement', this.requirement);
      param.append('file', this.file);
      param.append('accountName', this.accountName);
      ApiService.post('/task/release.htm', param, {
        'Content-Type': 'multipart/form-data'
      })
        .then(() => {
          this.hide();
        })
        .catch(() => {
          this.hide();
        });
    },
    addFile() {
      this.$refs.file.click();
    },
    handleFileUpload() {
      this.file = this.$refs.file.files[0];
      if (this.file) {
        let reader = new FileReader();
        reader.readAsDataURL(this.file);
        reader.onloadend = () => {
          this.fileThumb = reader.result;
        };
      }
    }
  }
};
</script>
